// extracted by mini-css-extract-plugin
export default {"timelineAxis":"timeline-axis_timelineAxis__ix4ax","roundSecond":"timeline-axis_roundSecond__720T+"};